import RockerIcon from '@/assets/icons/api-integration/rocket.svg?react'
import WrenchIcon from '@/assets/icons/api-integration/wrench.svg?react'
import GlobeIcon from '@/assets/icons/api-integration/globe.svg?react'

export const options = [
  {
    icon: RockerIcon,
    title: 'Real-time sync',
    description: 'Data is collected and synced with connected systems in real time, ensuring superior data quality.'
  },
  {
    icon: WrenchIcon,
    title: 'Customized to Your Needs',
    description: 'We’ll work with you to ensure Trackmate data translates to your ERP and other internal systems.'
  },
  {
    icon: GlobeIcon,
    title: 'Streamlined Workflows',
    description: 'Enable your employees and field workers with simple workflow solutions that make their jobs easier.'
  }
]